export const H36 = () => (
  <>
    <img src="/assets/images/other/22_10_04_HOFMANN_01.jpg" alt="" />

    <img src="/assets/images/other/22_10_04_HOFMANN_02.jpg" alt="" />
  </>
);
